import { INTERNAL_PATHS } from "routes/paths";

export const REFER_A_FRIEND_FAQ = [
  {
    id: 1,
    question: "How can I track my earnings?",
    response: (
      <p>
        Keep track of the GCX Cash you earn in My GCX Cash. You can see how much
        GCX Cash you have available and which friends helped you earn it.
      </p>
    )
  },
  {
    id: 2,
    question: "Do earnings expire?",
    response: (
      <p>
        When you earn GCX Cash via our referral program, it expires six months
        from the date you earned it, so don’t miss out on these extra savings!
      </p>
    )
  },
  {
    id: 3,
    question: "How do I redeem GCX Cash?",
    response: (
      <p>
        GCX Cash will be applied automatically for you at checkout, or you can
        save it for a future gift card purchase. Your order total must be
        greater than the amount of GCX Cash you apply. Please note, GCX Cash
        cannot be redeemed in combination with promo codes unless otherwise
        specified. See{" "}
        <a href={INTERNAL_PATHS.RAISE_CASH_TERMS}>
          GCX Cash Terms and Conditions
        </a>
        .
      </p>
    )
  }
];
